import { cn } from "@/lib/utils"

// shadcn's skeleton as defined (ui.shadcn.com/docs/components/skeleton): a
// quiet pulse on the accent surface, no travelling band. Reduced motion holds
// it still; the block alone still reads as "loading".
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-md bg-accent motion-reduce:animate-none", className)}
      {...props}
    />
  )
}

export { Skeleton }
